<template>
  <div class="msg-detail">
    <navigation sticky>消息详情</navigation>
    <section class="content" >
      <div class="title">文件签署通知</div>
      <p class="time">{{ detail.createTime | formateDate('YYYY/MM/DD HH:mm') }}</p>
      <div class="text">
        <p>尊敬的用户，为了维护您的合法权益，在您确认签署附件文件之前，请您务必仔细阅读文件内容，详见附件。如您对文件内容有疑义，请及时联系我们，以便我们充分为您答疑。</p>
      </div>  
      <div class="protocol-content" >
        <div class="protocol-content-title">请详阅附件内容。</div>
        <div v-for="(item) in detail.content.paramObj" :key="item.url">
          <a :href="item.url" target="adsd">{{ item.name }}</a>
        </div>
      </div>
    </section>
    <div class="footer" v-if="detail.verificationMode!=='NON'">
      <nd-button @click="handleVerifi" :disabled="$route.query.result === 'PASS'">我已阅读，并确认同意以上内容</nd-button>
      <auth :verificationMode="detail.verificationMode" ref="auth"></auth>
    </div>
  </div>
</template>

<script>

import Auth from './components/auth.vue'
import { mapActions } from 'vuex'
export default {
  components: {
    Auth
  },
  data () {
    return {
      detail: {
        content: {
          paramObj: []
        }
      },
      content: ''
    }
  },
 
  async mounted () {
    this.getDetail()
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('message', ['messageDetail', 'messageRead']),
    handleVerifi () {
      this.$refs.auth.handleVerifi()
    },
    read () {
      this.messageRead({
        recordNo: this.$route.query.recordNo
      })
    },
    async getDetail () {
      const { success, data } = await this.messageDetail({
        recordNo: this.$route.query.recordNo
      })
      if (success && data) {
        this.detail = data
        this.content = data.content?.text
        if (this.detail.read === 'N') {
          this.read()
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.msg-detail {
  height: 100vh;
 
  .content {
    padding: 20px;
    padding-bottom: 250px;
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
    border-top: 20px solid #fafafa;
    font-size: 28px;

   /deep/ .title {
      text-align: center;
      font-size: 36px;
      font-weight: bold;
    }
    /deep/ .text {
      &.tr {text-align: right;}
      margin-top: 15px;
    }
    iframe {
      width: 100%;
      height: 100%;
      border: none;
    }
  }
}
.footer {
  display: flex;
  bottom: 0;
  height: 180px;
  background: #ffffff;
  box-shadow: 0 -1px 3px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  position: fixed;
  bottom: 0;
  width: 10rem;
  justify-content: center;
  align-items: center;
}
.protocol-content{
  margin-top: 120px;
  background-color: #EEEEEE;
  border-radius: 10px;
  padding: 20px;
  .protocol-content-title{
    margin-bottom: 20px;
  }
  a{
    padding: 5px 0;
    display: block;
    font-size: 24px;
    margin-left: 5px;
    color: #1E90FF;
  }
}
</style>